import React from "react";

const SimpleCard = ({ children, loading = false }) => (
  <div className={`${loading ?? "loading"} simple-card`}>{children}</div>
);

export default SimpleCard;
